module.exports = __webpack_public_path__ + "static/media/floral-design-of-one-flower-lines-and-small-circles-svgrepo-com (1).d1975971.svg";